import { Supply } from './actions/supply';
import { SupplyFrom } from './actions/supplyFrom';
import { SupplyTo } from './actions/supplyTo';
import { Withdraw } from './actions/withdraw';
import { WithdrawFrom } from './actions/withdrawFrom';
import { WithdrawTo } from './actions/withdrawTo';
import { AccountData } from './getters/accountData';
import { BorrowBalanceOf } from './getters/borrowBalanceOf';
import { CollateralBalanceOf } from './getters/collateralBalanceOf';
import { GetAssetInfo } from './getters/getAssetInfo';
import { GetPrice } from './getters/getPrice';
import { IsBorrowCollateralized } from './getters/isBorrowCollateralized';
var actions = {
    Supply: Supply,
    SupplyFrom: SupplyFrom,
    SupplyTo: SupplyTo,
    Withdraw: Withdraw,
    WithdrawFrom: WithdrawFrom,
    WithdrawTo: WithdrawTo,
};
var getters = {
    CollateralBalanceOf: CollateralBalanceOf,
    IsBorrowCollateralized: IsBorrowCollateralized,
    AccountData: AccountData,
    BorrowBalanceOf: BorrowBalanceOf,
    GetAssetInfo: GetAssetInfo,
    GetPrice: GetPrice,
};
var CompoundV3 = {
    actions: actions,
    getters: getters,
};
export { CompoundV3 };
